import { useState, useEffect, useRef } from "react";   
import * as helper from '../global/helper';                 
import swal from 'sweetalert2';                     
import { getGstReportData } from "../api/reportsAPI";
import moment from "moment";
import RateBar from "./ratebar.js";
import { getAdminSettlementOptions } from "../api/teeTimeAPI.js";

const BookGstReport = (props) => {

    const [selectedFromDate,                setSelectedFromDate]         = useState(moment().toDate());
    const [selectedToDate,                  setSelectedToDate]           = useState(moment().toDate());
    const [isInit,                          setIsInit]                   = useState(true);
    const [gstReport,                       setGstReport]                = useState(null);
    const [gstTable,                        setGstTable]                 = useState(null);
    const [rateDetails,                     setRateDetails]              = useState({
        totalAmount: 0,
        totalTax: 0,
        finalAmount: 0,
        fromDate: '',
        toDate: '',
        total: 0,
        totalBooking: 0,
        type: "Total Bookings"
    });

    const settlementOptionsMap = useRef({});

    useEffect(() => {
        props.title('Book GST Report', 'tee-gst-report');

        $('#txtFromDate').datepicker({
            format: 'dd-mm-yyyy',
            minDate: new Date(),
        });  
        $('#txtFromDate').on('change', function (event) {
            setSelectedFromDate(event.target.value)
        }); 
        $('#txtToDate').datepicker({
            format: 'dd-mm-yyyy',
            minDate: new Date(),
        });  
        $('#txtToDate').on('change', function (event) {
            setSelectedToDate(event.target.value)
        });

        getGstReport();
        fetchSettlementOptions(); // fetch settlementOptions for db to map PaymentMethod in KTDataTable
    }, []);

    useEffect(() => {
        if (!isInit) {
            fillTable();
        }
    }, [gstReport]);

    useEffect(() => {
        if (gstReport && gstReport.GstSheet && gstReport.GstSheet.length > 0) {
            let totalAmount         = gstReport.GstSheet.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);
            totalAmount             = totalAmount.toFixed(2)
            let totalTax            = (parseFloat(totalAmount) * 18) / 100;
            totalTax                = totalTax.toFixed(2);
            let finalAmount         = parseFloat(totalAmount) + parseFloat(totalTax);
            finalAmount             = Math.round(finalAmount);
            finalAmount             = finalAmount.toFixed(2);

            setRateDetails({
                totalAmount,
                totalTax,
                finalAmount,
                fromDate: moment(selectedFromDate, 'DD-MM-YYYY').format('DD MMM, YYYY'),
                toDate: moment(selectedToDate, 'DD-MM-YYYY').format('DD MMM, YYYY'),
                total: gstReport.GstSheet.length,
                type: 'Total Bookings'
            });
        } else {
            setRateDetails({
                totalAmount: 0,
                totalTax: 0,
                finalAmount: 0,
                fromDate: moment(selectedFromDate, 'DD-MM-YYYY').format('DD MMM, YYYY'),
                toDate: moment(selectedToDate, 'DD-MM-YYYY').format('DD MMM, YYYY'),
                total: 0,
                type: 'Total Bookings'
            });
        }
    }, [gstReport]);


    const getGstReport = async() => {
        try {
            swal.fire({
                titleText: 'Loading',
                text: 'Please Wait...',
                showConfirmButton: false,
                onOpen: () => {
                    swal.showLoading();
                }
            });

            const response = await getGstReportData(moment(selectedFromDate, 'DD-MM-YYYY').format('YYYY-MM-DD'), moment(selectedToDate, 'DD-MM-YYYY').format('YYYY-MM-DD'));  
            // const response = [];
            
            if (response.status == 'error') {
                swal.fire({
                    icon: 'info',
                    titleText: 'No Data',
                    text: response.message
                });
                return;
            }

            isInit ? setIsInit(false) : $('#tblTeeGstReport').KTDatatable().destroy();
            setGstReport(response);
            swal.close();
        } catch (err) {
            swal.fire({
                icon      : 'error',
                titleText : err.message
            });
        }
    };

    const fetchSettlementOptions = async () => {
        try {
            const response = await getAdminSettlementOptions();
            const options = response?.settlementOptions;
            if (options) {
                settlementOptionsMap.current = options.reduce((map, o) => {
                    map[o.ID] = o.Name;
                    return map;
                }, {});
            }
            return;
        } catch (err) {
            swal.fire({
                icon      : 'error',
                titleText : err.message
            });
        }
    };

    function fillTable() {
        swal.close();
        // const gstSheet = gstReport.GstSheet;
        const gstSheet = gstReport?.GstSheet?.sort((a, b) => {
            const aDateTime = moment(`${a.BookDate} ${a.Slot}`, "YYYY-MM-DD HH:mm:ss h:mm A");
            const bDateTime = moment(`${b.BookDate} ${b.Slot}`, "YYYY-MM-DD HH:mm:ss h:mm A");

            const dateTimeDiff = aDateTime.diff(bDateTime);
            if (dateTimeDiff !== 0) return dateTimeDiff;

            return Number(a.TeeBox) - Number(b.TeeBox);
        }) || [];

        const tblGstSheet = $('#tblTeeGstReport').KTDatatable({
            data: {
                saveState: false,
                source: gstSheet,
            },
            layout: {
                scroll: false,
                footer: false,
            },
            sortable: false,
            pagination: false,
            search: { input: $('#generalSearch') },
            columns: [
                {                    
                    field: 'TransactionDate',
                    title: 'Bill Dt',
                    width: 80,
                    template: function (row) {
                        if (row.TransactionDate == null) {
                            return "";
                        } else {
                            return moment(row.TransactionDate).format('DD-MM-YYYY');
                        }
                    }
                },
                {
                    field: 'BookDate',
                    title: 'Game Dt',
                    width: 80,
                    template: function (row) {
                        if (row.BookDate == null) {
                            return "";
                        } else {
                            return moment(row.BookDate).format('DD-MM-YYYY');
                        }
                    }
                },
                {
                    field: 'Slot', title: 'Slot', width: 55,
                },
                {
                    field: 'TeeBox', title: 'TeeBox', width: 55,
                },
                {
                    field: 'Hole', title: 'Holes', width: 55,
                },
                {
                    field: 'TotalPlayer', title: 'Players', width: 55,
                },
                {
                    field: 'SubCategoryName', title: 'Category'
                },
                {
                    field: 'MembershipNo', title: 'Mem. No', width: 120
                },
                {
                    field: 'BookedBy', title: 'Booked By'
                },
                {
                    field: 'PaymentType', title: 'Pay Type', width: 70
                },
                {
                    field: 'PaymentMethod',
                    title: 'Pay.Mode',
                    width: 70,
                    template: function (row) {
                        return settlementOptionsMap.current[row.PaymentMethod] || '-';
                    }
                },
                {
                    field: 'TrackingID', title: 'Tracking ID', width: 170,                    
                },
                {
                    field: 'BillNo', title: 'Bill No', width: 140
                },
                {
                    field: 'FinalAmount', title: 'Bill Amt', width: 100
                },
                {
                    field: 'CompanyName', title: 'Company'
                },
                {
                    field: 'GSTNumber', title: 'GST No'
                }
            ],
            rows: { autoHide: false }
        });

        $('#root .kt-grid--hor').addClass('max-width100');
        $('#tblTeeGstReport .kt-datatable__table').addClass('overflow-x-auto');

        Config.Core.InitPopover();
        Config.Core.GrabAndScroll('.kt-datatable__table');

        const GstTable = $('.kt-datatable__table').tableExport({
            formats: ["xlsx", "csv"],
            headers: true,
            filename: `${moment(selectedFromDate, "DD-MM-YYYY").format("DD-MM-YYYY")} - To - ${moment(selectedToDate, "DD-MM-YYYY").format("DD-MM-YYYY")} - Book GST Report`
        });

        setGstTable(GstTable);
        $('.tableexport-caption').addClass('hidden');
    }

    function exportSheet(type) {
        let fileName = `${moment(selectedFromDate, 'DD-MM-YYYY').format('DD-MM-YYYY')} - To - ${moment(selectedToDate, 'DD-MM-YYYY').format("DD-MM-YYYY")} - Book GST Report`;
        gstTable.update({
            headers: true,
            formats: ["xlsx", "csv"],
            filename: fileName // pass in a new set of properties
        });

        if (type == 'xlsx') {
            $('.button-default.xlsx').click();
        } else {
            $('.button-default.csv').click();
        }
        $('.tableexport-caption').addClass('hidden');
    }

    const validateDate = async() => {
        let isValid = true;

        if (moment(selectedToDate, 'DD-MM-YYYY').isBefore(moment(selectedFromDate, 'DD-MM-YYYY'))) {
            isValid = false;
            swal.fire({
                icon                : 'error',
                titleText           : 'Oops..',
                text                : 'To Date should be greater than From Date',
                buttonsStyling      : false,
                confirmButtonClass  : "btn btn-brand"
            });
            return;
        }
        if (isValid) {
            getGstReport();
        }
    };


    return (
        <>
            <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor padding-tb0" id="kt_content">
                <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid margin-t20">
                    <div className="kt-portlet">
                        <div className="kt-portlet__body padding-t20 padding-b0">
                            <div id="ControlHolder" className="kt-form kt-form--label-right padding-10" role="form">
                                <div className="row">
                                    <label className="col-form-label col-sm-1 text-right">From Date</label>
                                    <div className="form-group col-sm-2">
                                        <div className="input-group date">
                                            <input 
                                                id="txtFromDate" 
                                                name="txtFromDate" 
                                                type="text" 
                                                className="form-control" 
                                                placeholder="Select date"
                                                readOnly={ true }
                                                defaultValue={moment(selectedFromDate, 'DD-MM-YYYY').format('DD-MM-YYYY')}
                                            />
                                            <div className="input-group-append">
                                                <span className="input-group-text">
                                                    <i className="la la-calendar-check-o"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <label className="col-form-label col-sm-1 text-right">To Date</label>
                                    <div className="form-group col-sm-2">
                                        <div className="input-group date">
                                            <input 
                                                id="txtToDate" 
                                                name="txtToDate" 
                                                type="text" 
                                                className="form-control" 
                                                placeholder="Select date"
                                                readOnly={ true }
                                                defaultValue={moment(selectedFromDate, 'DD-MM-YYYY').format('DD-MM-YYYY')}
                                            />
                                            <div className="input-group-append">
                                                <span className="input-group-text">
                                                    <i className="la la-calendar-check-o"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-1">
                                        <button className="btn btn-label-success" type="button" id="btnSearch" aria-haspopup="true" aria-expanded="false" onClick={() => validateDate()}>
                                            <i className="la la-search"></i>
                                        </button>
                                    </div>
                                    <div className="form-group col-sm-2">
                                        <div className="input-group">
                                            <div className="kt-input-icon kt-input-icon--left">
                                                <input 
                                                    type="text" 
                                                    className="form-control clientSearch" 
                                                    placeholder="Search..." 
                                                    id="generalSearch"
                                                />
                                                <span className="kt-input-icon__icon kt-input-icon__icon--left"><span><i className="la la-search"></i></span></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-1">
                                        <div className="dropdown">
                                            <button className="btn btn-label-brand dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                Export
                                            </button>
                                            <div className="dropdown-menu " aria-labelledby="dropdownMenuButton" x-placement="bottom-start" style={{position: 'absolute', willChange: 'transform', top: '0px', left: '0px', transform: 'translate3d(0px, 38px, 0px)'}}>
                                                <button 
                                                    id="btn-export-excel" 
                                                    type="button" 
                                                    className="dropdown-item"
                                                    onClick={() => exportSheet('xlsx')}

                                                > Excel 
                                                </button>
                                                <button 
                                                    id="btn-export-csv" 
                                                    type="button" 
                                                    className="dropdown-item"
                                                    onClick={() => exportSheet('csv')}
                                                >  Csv </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <RateBar 
                                rateDetails = { rateDetails }
                            />
                            <div id="tblTeeGstReport" className="table table-bordered table-hover custom-datatable"></div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BookGstReport;